import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { fetchSendMessage, useDispatch, useSelector } from '../../stores';

import { Grid, Typography } from '@mui/material';
import { WhatsApp, KeyboardArrowRight } from '@mui/icons-material';
import { Button, ContentBox, Dropdown, Input } from '../../components';

import { handleApiReturn, handleErrors } from '../../utils';
import { supportOptions } from './resources';
import { validationSchema } from './validations';

import { palette } from '../../theme';

import packageJson from '../../../package.json';

export const Support: React.FC = () => {
  const dispatch = useDispatch();

  const { driverId } = useSelector((state) => state.profileReducer);
  const { supportLoading } = useSelector((state) => state.supportReducer);

  const [formData, setFormData] = useState({
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const MESSAGE_LIMIT = 255;

  const handleSubmit = () => {
    setErrors({});
    validationSchema
      .validate(formData, { abortEarly: false })
      .then(() => {
        const message = formData.subject
          ? `${formData.subject} - ${formData.message} (website - v${packageJson.version})`
          : '';
        dispatch(
          fetchSendMessage({
            driverId: driverId.toString(),
            message: message,
          }),
        ).then((res: any) => {
          handleApiReturn(
            res,
            () => {
              toast.success('Mensagem enviada com sucesso.');
            },
            null,
          );
          setFormData({
            subject: '',
            message: '',
          });
        });
      })
      .catch((err) => {
        setErrors(handleErrors(err));
      });
  };

  return (
    <ContentBox loading={supportLoading}>
      <Grid
        container
        rowSpacing={1}
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: {
            xs: '20px',
            sm: 0,
          },
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography
            color='primary'
            sx={{ fontSize: '20px', fontWeight: 'bold' }}
          >
            Precisa de ajuda?
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography
            color={palette.text.main}
            sx={{
              fontSize: {
                xs: '15px',
                md: '18px',
              },
            }}
          >
            Escolha o assunto e faça uma breve descrição para nos ajudar a
            solucionar o problema.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography
            color={palette.text.main}
            sx={{
              fontSize: {
                xs: '13px',
                md: '16px',
              },
            }}
          >
            {process.env.REACT_APP_SUPPORT_EMAIL || ''}
          </Typography>
          <br />
          {!process.env.REACT_APP_WA_PHONE && (
            <Typography
              color={palette.text.main}
              sx={{
                fontSize: {
                  xs: '13px',
                  md: '16px'
                }
              }}
            >
              {process.env.REACT_APP_SUPPORT_PHONE}
            </Typography>
          )}
          {!!process.env.REACT_APP_WA_PHONE && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}>
              <button
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, backgroundColor: '#25D366', color: '#FFFFFF', border: 'none', borderRadius: 8, cursor: 'pointer', padding: 5, fontSize: 18 }}
                onClick={() => {
                  const phone = `+55 ${process.env.REACT_APP_WA_PHONE}`.replace(/[ +_()-]/g, '');
                  const text = 'Olá, estou no site motorista e preciso de um suporte.';
                  const link = `https://wa.me/${phone}/?text=${text}`;

                  window.open(link, '_blank')!.focus();
                }}
              >
                <WhatsApp />
                {process.env.REACT_APP_WA_PHONE}
                <KeyboardArrowRight />
              </button>
            </div>
          )}
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            options={supportOptions}
            data-testid='subject'
            margin='normal'
            label='Assunto'
            type='text'
            value={formData.subject}
            onChange={(value) => {
              setErrors({});
              setFormData({ ...formData, subject: value });
            }}
            errorMessage={errors && errors.subject}
          />
        </Grid>
        <Grid item xs={12} sx={{ height: 168, marginBottom: '20px' }}>
          <Input
            data-testid='message'
            type='text'
            margin='normal'
            label='Mensagem'
            multiline
            counter
            inputProps={{ maxLength: MESSAGE_LIMIT }}
            rows={6}
            value={formData.message}
            variant='standard'
            onChange={(value) => {
              setErrors({});
              setFormData({ ...formData, message: value });
            }}
            errorMessage={errors && errors.message}
          />
        </Grid>
      </Grid>
      <Grid
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          margin: 'auto',
          paddingTop: '20px',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button
          variant='contained'
          label='Enviar'
          type='submit'
          onClick={handleSubmit}
          color='secondary'
          loading={supportLoading}
          style={{ width: '100%', marginTop: 10 }}
        />
      </Grid>
    </ContentBox>
  );
};